import React, { useContext, useState } from "react";
import { useQuery } from "react-query";

import { QK } from "../../../base/qk";
import { getNEWS2 } from "../../../api/services/observations";
import { formatDateTime } from "../../../base/FormatTime";
import TableComponent from "../../TableComponent/TableComponent";
import { Chip } from "@mui/material";
import { getRiskLevelColor } from "../../Clients/ClientDetails/WhatElse/Observation/NEWS2/news2.config";
import { getUnAllocatedCandidates } from "../../../api/services/candidate";
import MyContext from "../../../context/MyContext";

const UnAllocatedCandidates = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { locationID } = useContext(MyContext);

  const resultPerPage = 10;

  const { data: unallocatedCandidates, isLoading } = useQuery(
    [QK.unallocatedCandidates, currentPage, locationID],
    () => getUnAllocatedCandidates(currentPage, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = unallocatedCandidates?.count || 0;
  const totalPages = Math.ceil(totalRecords / resultPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const columns = [
    {
      field: "candidate_name",
      headerName: " Candidate Name",
    },
    { field: "maximum_weekly_hours", headerName: "Maximum Hour" },
    {
      field: "assigned_hours",
      headerName: "Assigned",
    },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={unallocatedCandidates?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="medium"
      />
    </div>
  );
};

export default UnAllocatedCandidates;
